module.exports = __webpack_public_path__ + "static/media/delete.62eefd11.svg";